// listings.js
export const LOAD_LISTINGS = "LOAD_LISTINGS";
export const LOAD_LISTINGS_START = "LOAD_LISTINGS_START";
export const LOAD_LISTINGS_SUCCESS = "LOAD_LISTINGS_SUCCESS";
export const LOAD_LISTINGS_FAIL = "LOAD_LISTINGS_FAIL";
export const UPDATE_LOADED_LISTINGS = "UPDATE_LOADED_LISTINGS";
export const CHANGE_ACTIVE_PAGE = "CHANGE_ACTIVE_PAGE";

// share.js
export const SHOW_SHARE_URL = "SHOW_SHARE_URL";
export const HIDE_SHARE_URL = "HIDE_SHARE_URL";

// listing.js
export const SHOW_SPECIFIC_LISTING = "SHOW_SPECIFIC_LISTING";
export const LOAD_SPECIFIC_LISTING = "LOAD_SPECIFIC_LISTING";
export const LOAD_SPECIFIC_LISTING_START = "LOAD_SPECIFIC_LISTING_START";
export const LOAD_SPECIFIC_LISTING_SUCCESS = "LOAD_SPECIFIC_LISTING_SUCCESS";
export const LOAD_SPECIFIC_LISTING_FAIL = "LOAD_SPECIFIC_LISTING_FAIL";

// snackbar.js
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";

// user.js

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

// dashboard.js

export const LOAD_LISTING_DASHBOARD = "LOAD_LISTING_DASHBOARD";
export const LOAD_LISTING_DASHBOARD_START = "LOAD_LISTING_DASHBOARD_START";
export const LOAD_LISTING_DASHBOARD_FAIL = "LOAD_LISTING_DASHBOARD_FAIL";
export const LOAD_LISTING_DASHBOARD_SUCCESS = "LOAD_LISTING_DASHBOARD_SUCCESS"

// export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
// export const REGISTER_FAIL = "REGISTER_FAIL";
